module.exports = __webpack_public_path__ + "static/s4-object-fbbcfb6d975601313f2b7cd8691095f8.png";